const initialState = {
  author: "",
  cetagory: "",
  input: "",
};
export default initialState;
